import React from 'react';
import { Alert, Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material';
import SearchableSelect from './search/SearchableSelect';

export function occurrenceDate(data, serverDate) {
  const [year, month] = serverDate.split('-').map(Number);
  const dueMonth = data.frequency === 'yearly' ? Number(data.month_of_year) : month;
  const day = Number(data.day_of_month);
  if (!Number.isInteger(dueMonth) || dueMonth < 1 || dueMonth > 12 || !Number.isInteger(day)
      || day < 1 || day > new Date(Date.UTC(year, dueMonth, 0)).getUTCDate()) return null;
  return `${year}-${String(dueMonth).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

export function PaymentTypeField({ data, onChange }) {
  return <FormControl fullWidth sx={{ mt: 2 }}>
    <InputLabel id="recurring-type-label">Payment / Transfer</InputLabel>
    <Select labelId="recurring-type-label" name="payment_type" label="Payment / Transfer"
      value={data.payment_type || 'payment'} onChange={onChange}>
      <MenuItem value="payment">Payment</MenuItem><MenuItem value="transfer">Transfer</MenuItem>
    </Select>
  </FormControl>;
}

export function TransferDestinationFields({ data, accounts, categories, onChange }) {
  if (data.payment_type !== 'transfer') return null;
  return <Stack spacing={2} sx={{ mt: 2 }}>
    <Alert severity="info">Records an allocation transfer only. It does not send a bank or Zelle payment.</Alert>
    <FormControl fullWidth>
      <InputLabel>To account</InputLabel>
      <SearchableSelect name="to_account_id" label="To account" value={data.to_account_id || ''} onChange={onChange}>
        {accounts.filter(a => a.account_status !== 'archived' && a.is_active !== false)
          .map(a => <MenuItem key={a.id} value={a.id}>{a.name}</MenuItem>)}
      </SearchableSelect>
    </FormControl>
    <FormControl fullWidth>
      <InputLabel>To category</InputLabel>
      <SearchableSelect name="to_category_id" label="To category" value={data.to_category_id || ''} onChange={onChange}>
        {categories.filter(c => c.account_id === Number(data.to_account_id) && !c.is_deleted)
          .map(c => <MenuItem key={c.id} value={c.id}>{c.name}</MenuItem>)}
      </SearchableSelect>
    </FormControl>
    <Typography variant="body2">The source is debited and the destination is credited together. Both entries are transfers, regardless of category names.</Typography>
  </Stack>;
}

export function RecordOccurrenceField({ data, serverDate, existing, onChange }) {
  const due = occurrenceDate(data, serverDate);
  const period = data.frequency === 'yearly' ? `Y:${serverDate.slice(0, 4)}` : `M:${serverDate.slice(0, 7)}`;
  const samePeriod = data.frequency === 'yearly'
    ? existing?.scheduled_date?.slice(0, 4) === serverDate.slice(0, 4)
    : existing?.scheduled_date?.slice(0, 7) === serverDate.slice(0, 7);
  const recorded = existing && (existing.period_key === period || samePeriod) ? existing : null;
  const label = due ? new Date(`${due}T12:00:00Z`).toLocaleDateString(undefined,
    { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC' }) : null;
  return <Stack spacing={1} sx={{ mt: 2 }}>
    {recorded ? <Alert severity="info">Already recorded for this period ({recorded.scheduled_date}, {recorded.payment_type}). Saving changes future settings only; it will not rewrite or repeat that occurrence.</Alert>
      : <>
        <FormControlLabel control={<Checkbox name="record_now" checked={!!data.record_now}
          disabled={!due || due > serverDate || data.is_active === false}
          onChange={event => onChange({ target: { name: 'record_now', value: event.target.checked } })} />}
          label={label ? `Record the ${label} occurrence now` : 'Choose a valid schedule to record an occurrence'} />
        {due && due > serverDate && <Typography variant="body2">This occurrence is not due yet.</Typography>}
        {data.record_now && <Alert severity="info">Saving records this occurrence now. Scheduled processing and catch-up will skip it afterward. This does not send a payment.</Alert>}
      </>}
  </Stack>;
}
